"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "folgaria": {
    "5fb40bec": [{
      "hkey": "b71e5939",
      "slug": "costa",
      "name": "Costa",
      "primary": true,
      "skipSearch": false
    }],
    "costa-di-folgaria": [{
      "hkey": "b71e5939",
      "slug": "costa",
      "name": "Costa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "9fc67393": [{
      "hkey": "9095bd31",
      "slug": "folgaria",
      "name": "Folgaria",
      "primary": true,
      "skipSearch": false
    }],
    "fondo-piccolo": [{
      "hkey": "9095bd31",
      "slug": "folgaria",
      "name": "Folgaria",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;